/// <amd-module name="Build/Run/Components/NoData" />
import * as React from "react";

import * as Resources from "Build/Run/Resources";

import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { Page } from "VSSUI/Page";

export function NoData() {
    return <Page className="run-no-data">
        <MessageCard severity={MessageCardSeverity.Error}>
            {Resources.NoBuildData}
        </MessageCard>
    </Page>;
}